module.exports = __webpack_public_path__ + "static/media/mainimg-09.a97d4448.png";